import React, { SyntheticEvent } from "react";
import { NavLink } from "react-router-dom";
import { Dropdown, DropdownItemProps, Icon, Menu } from "semantic-ui-react";

import UserRole from "../../data/enums/UserRole";
import IUser from "../../data/user/User";
import { ReactComponent as AppLogo } from "../../static/favicon.svg";
import BoldFM from "../../util/styledMessages/BoldFM";

interface ITopNavbarComputerProps {
    language: string;
    allLanguagesConfig: DropdownItemProps[] | undefined;
    handleLanguageChange: (_: SyntheticEvent<HTMLElement, Event>, { value }: any) => void;
    handleLogout: () => void;
    user: IUser | undefined;
    currentURL: string;
}

const TopNavbarComputer: React.FC<ITopNavbarComputerProps> = (props: ITopNavbarComputerProps) => {
    const { language, allLanguagesConfig, handleLanguageChange, handleLogout, user, currentURL } = props;

    return (
        <Menu borderless color="grey" compact fixed="top" fluid inverted={false} stackable>
            <Menu.Item header style={{ paddingBottom: "0px", paddingTop: "0px" }}>
                <AppLogo
                    style={{
                        height: "32px",
                        width: "32px",
                        marginRight: "4px"
                    }}
                />
                <span style={{ color: "#6435c9" }}>
                    <BoldFM id="menu.title" />
                </span>
            </Menu.Item>
            <Menu.Item as={NavLink} exact to="/">
                <Icon color="violet" exact name="home" />
                <BoldFM id="menu.home" />
            </Menu.Item>
            {user && (
                <>
                    <Menu.Item
                        as={Dropdown}
                        className={currentURL.includes("/search") && !currentURL.includes("/suggestions") ? "selected" : ""}
                        simple
                        trigger={
                            <>
                                <Icon color="violet" name="search" />
                                <BoldFM id="menu.search" />
                            </>
                        }
                    >
                        <Dropdown.Menu>
                            <Dropdown.Item as={NavLink} to="/priests/search">
                                <Icon color="violet" name="user" />
                                <BoldFM id="menu.searchPriests" />
                            </Dropdown.Item>
                            <Dropdown.Item as={NavLink} to="/parishes/search">
                                <Icon color="violet" name="users" />
                                <BoldFM id="menu.searchParishes" />
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Menu.Item>

                    <Menu.Item as={NavLink} to="/charts">
                        <Icon color="violet" name="pie graph" />
                        <BoldFM id="menu.charts" />
                    </Menu.Item>

                    {[UserRole.OWNER, UserRole.ADMIN, UserRole.EDITOR].includes(user.role) && (
                        <Menu.Item
                            as={Dropdown}
                            className={currentURL.includes("/create") ? "selected" : ""}
                            simple
                            trigger={
                                <>
                                    <Icon color="violet" name="add" />
                                    <BoldFM id="menu.add" />
                                </>
                            }
                        >
                            <Dropdown.Menu>
                                <Dropdown.Item as={NavLink} to="/priests/create">
                                    <Icon color="violet" name="user" />
                                    <BoldFM id="menu.addPriest" />
                                </Dropdown.Item>
                                <Dropdown.Item as={NavLink} to="/parishes/create">
                                    <Icon color="violet" name="users" />
                                    <BoldFM id="menu.addParish" />
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </Menu.Item>
                    )}

                    {[UserRole.OWNER, UserRole.ADMIN, UserRole.EDITOR].includes(user.role) && (
                        <Menu.Item as={NavLink} to="/suggestions/search">
                            <Icon color="violet" name="lightbulb" />
                            <BoldFM id="menu.suggestions" />
                        </Menu.Item>
                    )}

                    {[UserRole.OWNER, UserRole.ADMIN].includes(user.role) && (
                        <Menu.Item as={NavLink} to="/administration">
                            <Icon color="violet" name="user secret" />
                            <BoldFM id="menu.admin" />
                        </Menu.Item>
                    )}
                </>
            )}
            {!user ? (
                <>
                    <Menu.Item as={NavLink} position="right" to="/login">
                        <Icon color="violet" name="sign in" />
                        <BoldFM id="menu.login" />
                    </Menu.Item>

                    <Menu.Item as={NavLink} to="/register">
                        <Icon color="violet" name="signup" />
                        <BoldFM id="menu.register" />
                    </Menu.Item>
                </>
            ) : (
                <>
                    <Menu.Item position="right">{user.name}</Menu.Item>

                    <Menu.Item onClick={handleLogout}>
                        <Icon color="violet" name="log out" />
                        <BoldFM id="menu.logout" />
                    </Menu.Item>
                </>
            )}
            <Menu.Item link style={{ marginLeft: "2vw" }}>
                <Dropdown onChange={handleLanguageChange} options={allLanguagesConfig} value={language} />
            </Menu.Item>
        </Menu>
    );
};

export default TopNavbarComputer;
